<template>
	<div class="container-fluid">
		<time-logs-toolbar heading="Time Log History"></time-logs-toolbar>

		<div v-if="mutatedLogsToPayPeriods.length > 0 && !loading">

			<div class="float-right">
				<table style="font-size: 10pt;">
					<tr>
						<th style="padding-right: 5px;text-align: right;">Unreviewed</th>
						<td style="background-color: #eff6ff;border:1px solid #ced5ea;width:50px;"></td>
					</tr>
					<tr>
						<th style="padding-right: 5px;text-align: right;">Reviewed</th>
						<td style="background-color: #f3ffef;border:1px solid #d5eace;width:50px;"></td>
					</tr>
					<tr>
						<th style="padding-right: 5px;text-align: right;">Pending Transfer Request</th>
						<td style="background-color: #ffefef;border:1px solid #eacece;width:50px;"></td>
					</tr>
				</table>
			</div>

			<field label="Pay Periods with Reviewable Logs" col-class="stacked" :params="{type:'btn-group',buttons:payPeriodButtons}" v-model="selectedPayPeriod"></field>

			<div v-if="mutatedLogsToPayPeriods[selectedPayPeriod] && mutatedLogsToPayPeriods[selectedPayPeriod].openLogs.length > 0">
				
				<div v-if="!openLogsVisible" class="alert alert-warning">
					<p>
						<i class="fa fa-exclamation-triangle"></i>
						There are some open time logs for this pay period still! They will need to be closed before the period can be closed out.
					</p>
					<a href="#" v-on:click="openLogsVisible = true">View Open Logs...</a>
				</div>

				<div v-else>
					<h3><i class="fa fa-chevron-up icon-button" v-on:click="openLogsVisible = false"></i> Open Logs</h3>

					<table-list key='open-logs'
						:records="mutatedOpenLogs"
						:fields="openLogFields"
						record-name="Open Log"
						:hide-record-count="true"
						id-field="slug"
						:has-edit="false">
					</table-list>
				</div>
			</div>

			<div v-if="mutatedLogsToPayPeriods[selectedPayPeriod] && mutatedLogsToPayPeriods[selectedPayPeriod].orphanedLogs.length > 0">
				<div v-if="!orphanedLogsVisible" class="alert alert-warning">
					<p>
						<i class="fa fa-exclamation-triangle"></i>
						There are some logs for this pay period that have somehow been detached from a project and/or user. They will need to be corrected and reviewed before the period can be closed out.
					</p>
					<a href="#" v-on:click="orphanedLogsVisible = true">View Orphaned Logs...</a>
				</div>

				<div v-else>
					<h3><i class="fa fa-chevron-up icon-button" v-on:click="orphanedLogsVisible = false"></i> Orphaned Logs</h3>

					<table-list
						:records="mutatedOrphanedLogs"
						:fields="orphanedLogFields"
						record-name="Orphaned Log"
						:hide-record-count="true"
						id-field="slug"
						:has-edit="true"
						v-on:edit="editTimeLog">
					</table-list>
				</div>
			</div>

			<time-log-review-table
				:pay-period="mutatedLogsToPayPeriods[selectedPayPeriod]"
				:logs="logs"
				:user-logs-fields="userLogsFields"
				:job-show-override="showAllLogs"

				v-on:editTimeLog="editTimeLog"
				v-on:submitStateChange="updateSubmitState"
				v-on:jobShowChange="jobShowToggle">
			</time-log-review-table>

			<div style="height: 60px"></div>

			<button v-if="allReviewableLogsApproved && periodHasUserReviewableLogs" 
				class="btn btn-lg btn-success float-right submit-log-button" 
				v-on:click="confirmModal.visible = true">

				<i class="fa fa-check"></i> 
				Approve &amp; Submit These Time Logs
			</button>
		</div>
		<div v-else-if="mutatedLogsToPayPeriods.length == 0 && logsLoaded && !noJobsManaged">
			<div class="alert alert-success text-center" style="max-width: 600px;margin:auto;margin-top: 50px;">
				<i class="fa fa-check fa-4x"></i>
				<p style="font-size: 20px">You're all caught up! No logs to review at the moment</p>

				<button v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Time Logs')" class="btn btn-primary btn-lg" v-on:click="jobShowToggle(true)">
					I want to look at reviewable logs anyway
				</button>
			</div>
		</div>
		<div v-else-if="mutatedLogsToPayPeriods.length == 0 && noJobsManaged">
			<div class="alert alert-success text-center" style="max-width: 600px;margin:auto;margin-top: 50px;">
				<i class="fa fa-check fa-4x"></i>
				<p style="font-size: 20px">Nothing to review! (You don't manage time logs on any project/service)</p>

				<button v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Time Logs')" class="btn btn-primary btn-lg" v-on:click="jobShowToggle(true)">
					I want to look at reviewable logs anyway
				</button>
			</div>

			
		</div>
		<div v-else-if="loading">
			<div class="skeleton-box" v-for="n in 3"></div>
		</div>

		<modal-dialog
			:modal-visible="confirmModal.visible"
			title="Submit Time Logs?"
			confirm-button-text="Yes, Submit"
			:working="submitting"
			v-on:confirm="submitTimeLogs"
			v-on:closeModal="confirmModal.visible = false">
			Submit these timelogs to Payroll? After you do this they will be locked and no longer editable.
		</modal-dialog>

		<time-log-edit-modal
			:visible="editModal.visible"
			:record="editModal.record"
			:show-transfer-button="true"
			:time-log-settings="timeLogSettings"
			:show-reviewed-button="true"
			:allow-user-edit="true"
			:allow-job-edit="true"
			:show-skip-mileage-per-diem="true"
			:has-comments="true"
			v-on:closeModal="editModal.visible = false"
			v-on:save="saveTimeLogEdit"
			v-on:openTransferModal="openTransferModal"
			v-on:reviewStatusChange="updateRecordReviewStatus"
			v-on:modelChanged="timeLogDeleted(editModal.record)">
		</time-log-edit-modal>

		<modal-dialog
			:modal-visible="transferModal.visible"
			title="Transfer Overtime Hours"
			confirm-button-text="Confirm"
			v-on:confirm="saveHoursTransfer"
			v-on:closeModal="transferModal.visible = false">

			<p>Use this form to transfer overtime hours from one time log to another time log of the same user on a different project.</p>

			<form-group v-if="timeLogSettings && timeLogSettings.uses_overtime_15x == 1 && editModal.record.overtime_hours_15x > 0" label="1.5x OT Hrs" col-class="col-md-4">
				<div class="row">
					<div class="col-sm-9">
						<input type="range" min="0" :max="editModal.record.overtime_hours_15x" step="0.25" v-model="transferModal.payload.overtime_hours_15x" class="form-control">
					</div>
					<div class="col-sm-3">
						<input type="number" min="0" :max="editModal.record.overtime_hours_15x" step="0.25"  class="form-control-plaintext" v-model="transferModal.payload.overtime_hours_15x">
					</div>
				</div>
			</form-group>

			<form-group v-if="timeLogSettings && timeLogSettings.uses_overtime_2x == 1 && editModal.record.overtime_hours_2x > 0" label="2x OT Hrs" col-class="col-md-4">
				<div class="row">
					<div class="col-sm-9">
						<input type="range" min="0" :max="editModal.record.overtime_hours_2x" step="0.25" v-model="transferModal.payload.overtime_hours_2x" class="form-control">
					</div>
					<div class="col-sm-3">
						<input type="number" min="0" :max="editModal.record.overtime_hours_2x" step="0.25" class="form-control-plaintext" v-model="transferModal.payload.overtime_hours_2x">
					</div>
				</div>
			</form-group>

			<form-group v-if="timeLogSettings && timeLogSettings.uses_overtime_25x == 1 && editModal.record.overtime_hours_25x > 0" label="2.5x OT Hrs" col-class="col-md-4">
				<div class="row">
					<div class="col-sm-9">
						<input type="range" min="0" :max="editModal.record.overtime_hours_25x" step="0.25" v-model="transferModal.payload.overtime_hours_25x" class="form-control">
					</div>
					<div class="col-sm-3">
						<input type="number" min="0" :max="editModal.record.overtime_hours_25x" step="0.25" class="form-control-plaintext" v-model="transferModal.payload.overtime_hours_25x">
					</div>
				</div>
			</form-group>

			<field 
				v-if="transferModal.payload.overtime_hours_15x > 0 || transferModal.payload.overtime_hours_2x > 0 || transferModal.payload.overtime_hours_25x > 0" 
				label="Send To (Project)" 
				col-class="col-md-4" 
				:params="{type: 'select', options: jobOptions}" 
				v-model="transferModal.payload.to_job_id" 
				v-on:change="fetchTransferLoadTimeLogs">	
			</field>

			<field v-if="transferModal.payload.to_job_id" label="Time Log" col-class="col-md-4" :params="{type: 'select', options: timeLogOptions}" v-model="transferModal.payload.to_log_id"></field>

			<div v-if="transferModal.payload.to_job_id && 'User' in editModal.record && selectedTimeLog">
				<p>This action will remove
					<strong v-if="transferModal.payload.overtime_hours_15x > 0">{{ transferModal.payload.overtime_hours_15x }} 1.5x OT hrs,</strong>
					<strong v-if="transferModal.payload.overtime_hours_2x > 0">{{ transferModal.payload.overtime_hours_2x }} 2x OT hrs,</strong>
					<strong v-if="transferModal.payload.overtime_hours_25x > 0">{{ transferModal.payload.overtime_hours_25x }} 2.5x OT hrs</strong>
					from <strong>{{ editModal.record.User.first_name }} {{ editModal.record.User.last_name }}'s</strong> time log at <strong>{{editModal.record.time_in}}</strong>
					on the <strong>{{ editModal.record.Job.job_name }}</strong> project
					and add it to his/her time log at <strong>{{ selectedTimeLog.time_in}}</strong> on the <strong>{{ selectedJob.job_name }}</strong> project.
				</p>
				<p>If you do not have authority to modify hours for this project, an approval notice will be sent prior to the change taking place.</p>
			</div>

		</modal-dialog>

	</div>
</template>

<script>

import TableList from "@/components/TableList"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import ModalDialog from "@/components/ModalDialog"
import TimeLogEditModal from "@/components/super_components/TimeLogEditModal"
import TimeLogReviewTable from "@/components/super_components/TimeLogReviewTable"
import TimeLogsToolbar from "./TimeLogsToolbar"

import TimeLogMixins from "@/mixins/TimeLogMixins"

export default {

	name: 'TimeLogsReview',
	components: {
		TimeLogsToolbar,
		TableList,
		Field,
		FormGroup,
		ModalDialog,
		TimeLogReviewTable,
		TimeLogEditModal
	},
	mixins: [TimeLogMixins],
	data() {
		return {
			jobs: [],
			transferTimeLogs: [],
			logs: [],
			mutatedLogsToPayPeriods: [],
			loading: true,
			logsLoaded: false,
			noJobsManaged: false,
			firstFetch: false,
			outstandingLogs: [],
			selectedPayPeriod: 0,
			payrollDays: {},
			timeLogSettings: {},
			showNotes: [],
			userLogsFields: [
				{label: "Time In",key: "timeInShort"},
				{label: "Time Out",key: "timeOutShort"},
				{label: "In/Out Diff",key: "timeDiff"},
				{label: "Reported Hrs",key: "regular_hours"},
				{label: "OT Hrs",key: "overtime_hrs"},
				{label: "Project",key: "projectName"},
				{label: "Reviewed By",key: "reviewedBy"},
			],
			editModal: {
				visible: false,
				record: {},
				job: null
			},
			transferModal: {
				visible: false,
				payload: {},
				record: {},
				jobs: []

			},
			confirmModal: {
				visible: false,
			},
			submitState: false,
			submitting: false,
			openLogFields: [
				{label: "Employee",key: "userName"},
				{label: "Time In",key:"timeInLocal"},
				{label: "Job #", key: "jobNum"},
				{label: "Project", key: "jobName"}
			],
			orphanedLogFields: [
				{label: "Employee",key: "userName"},
				{label: "Time In",key:"timeInLocal"},
				{label: "Time Out",key:"timeOutLocal"},
				{label: "Job #", key: "jobNum"},
				{label: "Project", key: "jobName"}
			],
			openLogs: [],
			openLogsVisible: false,
			orphanedLogsVisible: false,
			showAllLogs: false,
			logInclude:  [
				{
					model:"User",
					fields:["first_name","last_name"],
					include:[
						{
							model: "EmployeeClassification",
							include: ["Union"],
							fields: ["id","title","union_id"]
						},
						"EmployeeSetting"
					]
				},
				{
					model:"Job",
					fields:["id","slug","job_num","job_name","lat","long","customer_id","pays_perdiem","pays_mileage","Customer"],
					include:[
						{model: "Contact",fields:["id","slug","name"]}
					]
				},
				{
					model:"Service",
					fields:["job_num","job_name","lat","long","customer_id","Customer"],
					include:[{model: "Contact",fields:["id","slug","name"]}]
				},
				"PendingOvertimeTransfer",
				"PayBoost"
			],
		}
	},
	computed: {
		mutatedOpenLogs() {
			let vm = this

			if (this.mutatedLogsToPayPeriods[this.selectedPayPeriod] && "openLogs" in this.mutatedLogsToPayPeriods[this.selectedPayPeriod]) {

				return this.mutatedLogsToPayPeriods[this.selectedPayPeriod].openLogs.map(log => {
					log.userName = log.User.first_name+" "+log.User.last_name
					log.timeInLocal = vm.formatDateTimeToLocal(log.time_in)

					if ("Job" in log && log.Job) {
						log.jobName = log.Job.job_name
						log.jobNum = log.Job.job_num
					}
					else if ("Service" in log && log.Service) {
						log.jobName = log.Service.job_name
						log.jobNum = log.Service.job_num
					}
					else {
						log.jobNum = ""
						log.jobName = ""
					}


					return log
				})
			}
			return []
		},
		mutatedOrphanedLogs() {
			let vm = this

			if (!this.mutatedLogsToPayPeriods[this.selectedPayPeriod] || !("orphanedLogs" in this.mutatedLogsToPayPeriods[this.selectedPayPeriod]))
				return []

			return this.mutatedLogsToPayPeriods[this.selectedPayPeriod].orphanedLogs.map(log => {

				if (log.User)
					log.userName = log.User.first_name+" "+log.User.last_name
				else
					log.userName = "[No User]"

				log.timeInLocal = vm.formatDateTimeToLocal(log.time_in)
				log.timeOutLocal = vm.formatDateTimeToLocal(log.time_out)

				if ("Job" in log && log.Job) {
					log.jobName = log.Job.job_name
					log.jobNum = log.Job.job_num
				}
				else if ("Service" in log && log.Service) {
					log.jobName = log.Service.job_name
					log.jobNum = log.Service.job_num
				}
				else {
					log.jobNum = "[unassigned]"
					log.jobName = "[unassigned]"
				}


				return log
			})
		},
		reviewedLogsPayload() {
			let vm = this

			let payloadLogs = []

			if (this.submitting)
				return false

			vm.mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs.forEach(job => {

				if (job.reviewable) {
					job.users.forEach(user => {
						user.days.forEach(day => {
							day.logs.forEach(log => {
								if (log.reviewed_by > 0) {
									payloadLogs.push({
										id: log.id,
										submitted_by: vm.$store.userDetails.id,
										review_notes: log.review_notes
									})
								}
							})
						})
					})
				}
			})

			return payloadLogs
		},
		daysInPeriod() {
			let dayInterval
			if (this.timeLogSettings.interval == "weekly")
				dayInterval = 7
			else if (this.timeLogSettings.interval == "biweekly")
				dayInterval = 14

			return dayInterval
		},
		//converts mutatedLogsToPayPeriods into pay period buttons for the btn-group to select which pay period to look at
		payPeriodButtons() {
			let vm = this

			if (this.mutatedLogsToPayPeriods) {
				return this.mutatedLogsToPayPeriods.map((period,index) => {

					return {
						text: period.label,
						value: index
					}
				})
			}
			else
				return []

		},
		jobOptions() {
			let jobs = this.transferModal.jobs.map(job => {
				job.displayName = job.job_num + ": " + job.job_name
				return job
			})
			return this.optionify(jobs,"displayName")
		},
		timeLogOptions() {
			let vm = this
			return this.optionify(this.transferTimeLogs.map(log => {
				log.timeIn = vm.formatDateTimeToLocal(log.time_in)
				return log
			}),"timeIn")
		},
		selectedTimeLog() {
			let vm = this

			let selectedLog 
			this.transferTimeLogs.forEach(log => {
				if (log.id == vm.transferModal.payload.to_log_id)
					selectedLog = log
			})

			return selectedLog
		},
		selectedJob() {
			let vm  =this
			let selectedJob

			this.jobs.forEach(job => {
				if (job.id == vm.transferModal.payload.to_job_id)
					selectedJob = job
			})
			return selectedJob
		},
		periodHasUserReviewableLogs() {
			let has = false

			if (typeof this.mutatedLogsToPayPeriods[this.selectedPayPeriod] != 'undefined' && this.mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs) {
				this.mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs.forEach(job => {

					if (job.reviewable)
						has = true
				})
			}

			return has
		},
		allReviewableLogsApproved(){
			let allApproved = true

			if (typeof this.mutatedLogsToPayPeriods[this.selectedPayPeriod] != 'undefined' && this.mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs) {
				this.mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs.forEach(job => {

					if (job.reviewable) {
						job.users.forEach(user => {
							user.days.forEach(day => {
								day.logs.forEach(log => {
									if (log.reviewed_by == 0)
										allApproved = false
								})
							})
						})
					}
				})
			}

			return allApproved
		},
	},
	methods: {
		jobShowToggle(state) {
			let vm = this

			this.showAllLogs = state

			vm.spinner(true)

			this.fetchReviewableTimeLogs(state).then(response => {
				vm.spinner(false)
				vm.loading = false

				if (response.success) {

					vm.logsLoaded = true //prevents the "Complete" message from showing during load
					vm.logs = response.data

					vm.mutatedLogsToPayPeriods = vm.mutateLogsToPayPeriods(response.data,vm.timeLogSettings.interval,vm.timeLogSettings.initial_payday)
				}
			})
		},
		updateSubmitState(state) {
			this.submitState = state
		},
		showNote(name) {
			this.showNotes[name] = true
		},
		editTimeLog(record,job) {
			this.editModal.visible = true
			this.editModal.record = record
			this.editModal.job = job
		},
		timeLogDeleted(record) {
			//get index of record

			/*mutatedLogsToPayPeriods[this.selectedPayPeriod].jobs.forEach(job => {
				if (job.id == record.job_id || job.id == record.service_id) {
					job.users.forEach(user => {
						if (user.id == record.user_id) {
							user.days.forEach(day => {
								if (day.date == record.)
							})
						}
					})
				}

			})*/

			this.fetchData(false)
		},
		saveTimeLogEdit(payload) {
			let vm = this

			this.saveRecord("TimeLog",payload,response => {
				if (response.success == true) {
					vm.editModal.visible = false
					vm.fetchData(false)
				}
			})
		},
		/**
		* Updates record with new review status 
		**/
		updateRecordReviewStatus(record,newStatus) {
			record.reviewed_by = newStatus

			this.$bus.$emit("recordReviewStatusChange")
		},
		openTransferModal(payload) {
			this.transferModal.visible = true
			this.transferModal.payload = {
				id: payload.id,
				overtime_hours_15x: 0,
				overtime_hours_2x: 0,
				overtime_hours_25x: 0,
				to_job_id: null,
				to_log_id: null,
			}

			this.spinner(true)
			let vm = this

			this.getJSON("Job/get").then(response => {
				vm.spinner(false)

				vm.transferModal.jobs = response.data
			})

		},
		fetchTransferLoadTimeLogs() {
			this.spinner(true)

			let vm = this

			this.$nextTick(() => {

				let params = {
					filters: [
						["job_id",vm.transferModal.payload.to_job_id],
						["reviewed_by",0],
						["user_id",vm.editModal.record.user_id]
					]
				}

				vm.getJSON("TimeLog/get",params).then(response => {
					vm.transferTimeLogs = response.data

					vm.spinner(false)
				})

			})
			
		},
		saveHoursTransfer() {
			let vm = this

			this.postData("TimeLog/transfer-hours",this.transferModal.payload).then(response => {
				vm.transferModal.visible = false

				if (response.success) {
					vm.alertSuccess("An Overtime Transfer Request has been sent to the relevant Log Reviewers")
				}
				else
					vm.alertFail("There was a problem.")
			})
		},
		//mark logs as reviewed with API's batch save
		submitTimeLogs() {
			let vm = this

			let payload = {
				records: vm.reviewedLogsPayload
			}

			this.spinner(true,"Submitting...")

			this.submitting = true

			this.postData("TimeLog/save-batch",payload,true).then(response => {
				vm.spinner(false)
				vm.submitting = false

				if (response.success) {
					vm.confirmModal.visible = false
					vm.alertSuccess("Pay periods reviewed!")
					vm.fetchData(false)
				}
			})
		},
		fetchReviewableTimeLogs(all) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {}

				if (all)
					params.showAllReviewal = true

				vm.getJSON("TimeLog/get-reviewable-logs",params).then(response => {
					
					resolve(response)
				})

			})
		},
		fetchData(fetchSupportingResources) {
			let vm = this

			//only pull logs from 1 month old, otherwise let them fall off into obscurity
			let monthAgo = this.moment().subtract(1,"months").format("YYYY-MM-DD")

			let jobsInclude = [
				{
					model: "User",
					fields: ["id","first_name","last_name"],
				},
				{
					model: "JobPersonnelRole",
					fields: ["review_timelogs","user_id","title"]
				},
				{
					model: "Contact",
					fields: ["id","name"]
				}
			]

			let promises = [
				this.fetchReviewableTimeLogs(this.showAllLogs)
			]

			if (fetchSupportingResources)
				promises.push(this.getJSON("TimeLogSetting/get"))

			vm.spinner(true)

			if (!this.firstFetch)
				vm.loading = true

			Promise.all(promises).then(responses => {

				vm.spinner(false)
				vm.loading = false
				vm.logsLoaded = true
				vm.firstFetch = true

				let payPeriods = []

				if (responses.length > 1 && responses[1].data.length > 0)
					vm.timeLogSettings = responses[1].data[0]

				vm.mutatedLogsToPayPeriods = vm.mutateLogsToPayPeriods(responses[0].data,vm.timeLogSettings.interval,vm.timeLogSettings.initial_payday)

				console.log(vm.mutatedLogsToPayPeriods)

				if (vm.mutatedLogsToPayPeriods.length < vm.selectedPayPeriod)
					vm.selectedPayPeriod = "0"
				else if (vm.mutateLogsToPayPeriods[vm.selectedPayPeriod] == 'undefined')
					vm.selectedPayPeriod = 0
			})

			//fetch these lists but don't block the UI
			if (fetchSupportingResources) {
				this.fetchJobs([],false,["job_num","job_name"])
				this.fetchUsers([],false,["first_name","last_name"])
			}
		}
	},
	created() {
		this.fetchData(true)

	}
}
</script>

<style type="text/css" scoped>
	.submit-log-button {
		position: fixed;
		bottom: 10px;
		right: 10px;
		z-index: 10;
	}

	.skeleton-box {
		border-radius: 4px;
		background-color: #e0e0e0;
		width: 100%;
		height: 200px;
		animation: pulse 3s linear;
		margin-bottom: 20px;
	}

	@keyframes pulse {
		from {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>